module.exports = __webpack_public_path__ + "media/img/pages/profile/kpmg fr 3-68491817fceda97af2edd2f43dc50b5c.jpg";